<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { Icon, ChevronDown, XMark } from "svelte-hero-icons";
  import { cx } from "$lib/utils/cx";
  import { liveStore } from "../Automator/store";

  export let value;
  export let label;
  export let selectedApp;
  export let isReadonly = false;
  export let isOpen = false;

  const dispatch = createEventDispatcher();

  let displayValue;

  $: {
    if (value) {
      displayValue = `${value.original_filename || "Unknown"} (${value.sha256?.slice(0, 8) || "Unknown"})`;
    } else {
      displayValue = "Production";
    }
  }

  function handleClick() {
    if (!isReadonly) {
      isOpen = true;

      $liveStore.pushEvent("open_build_selector", {
        payload: {
          app_id: selectedApp,
        },
      });
    }
  }

  function clearValue() {
    if (!isReadonly) {
      value = null;
      dispatch("change", null);
    }
  }

  function handleModalResult(payload) {
    handleModalClose(payload);

    value = payload.build;

    dispatch("change", payload.build);
  }

  function handleModalClose(_payload) {
    isOpen = false;
  }

  onMount(() => {
    const selectedRef = $liveStore.handleEvent("build_selected", handleModalResult);
    const closedRef = $liveStore.handleEvent("build_selector_closed", handleModalClose);

    return () => {
      $liveStore.removeHandleEvent(selectedRef);
      $liveStore.removeHandleEvent(closedRef);
    };
  });
</script>

<div class="flex flex-col basis-full {isReadonly ? 'opacity-60' : ''}">
  <div aria-label="Select Build" class="w-full flex items-center {$$props.class || ''}">
    <div class="relative w-full">
      <button
        type="button"
        class="flex gap-2 items-center justify-between w-full h-8 text-left rounded p-2 pr-8 text-xs bg-gray-100 border-0 focus:outline-none truncate"
        class:cursor-not-allowed={isReadonly}
        class:focus:ring-2={!isReadonly}
        class:focus:ring-blue-500={!isReadonly}
        on:click={handleClick}
        disabled={isReadonly}
      >
        <span
          class="text-xs text-gray-500 whitespace-nowrap pointer-events-none transition-all truncate"
          class:cursor-not-allowed={isReadonly}
        >
          {label}
        </span>

        {displayValue}
      </button>

      <Icon
        src={ChevronDown}
        class={cx(
          "absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none",
          isReadonly && "opacity-50",
        )}
      />
    </div>
    <button
      type="button"
      class="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none"
      on:click={clearValue}
    >
      <Icon src={XMark} class="w-4 h-4" />
    </button>
  </div>
</div>
